export const article = [
  {
    articleId: 24,
    url: "solucionar-problemas-de-streaming-en-tu-dispositivo",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "Solucionar problemas de streaming en tu dispositivo",
    content: 
      <>
        <div className="row">
          <p>Si Mega GO no funciona en tu teléfono o tablet con Android, prueba estos pasos que pueden solucionar la mayoría de los problemas.</p>
        </div>
        <div className="rowLine">
          <h2>Apaga tu dispositivo y vuelve a encenderlo </h2>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Apaga tu dispositivo Android. Asegúrate de que esté apagado, no simplemente bloqueado.</li>
              <li>Vuelve a encenderlo.</li>
              <li>Vuelve a probar Mega GO.</li>
            </ul>
          </div>
        </div>
        <div className="">
          <h2>Borrar los datos de la aplicación de Mega GO</h2>
          <p>NOTA: Al borrar los datos de la app, se eliminará todo el contenido que hayas descargado en el dispositivo. </p>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Desde la pantalla de inicio de tu dispositivo, navega hasta Configuración.</li>
              <li>Selecciona <b>General</b>
                <ul className="disc">
                  <li>Si no ves General, ve al paso siguiente.</li>
                </ul>
              </li>
              <li>Selecciona Apps o Aplicaciones.</li>
              <li>Selecciona <b>Administrar aplicaciones, Administrador de aplicaciones</b> o <b>Administrar todas las apps.</b>
                <ul className="disc">
                  <li>Si no ves estas opciones, continúa con el paso siguiente.</li>
                </ul>
              </li>
              <li>Selecciona <b>Almacenamiento</b>
                <ul className="disc">
                  <li>Si no ves Almacenamiento, ve al paso siguiente. </li>
                </ul>
              </li>
              <li>Selecciona <b>Borrar datos</b> o <b>Borrar almacenamiento</b> y, luego, <b>Aceptar.</b></li>
              <li>Vuelve a probar Mega GO.</li>
            </ul>
            <p>NOTA: Algunos dispositivos Android no cuentan con la opción de borrar los datos de la aplicación de Mega GO. Si no puedes completar esos pasos, prueba con los pasos de resolución de problemas descritos a continuación. </p>
          </div>
        </div>
      </>
  }
];